<template>
  <div class="s-setting-container no-border">
    <div
      v-if="loadingPlans"
      class="loading-container"
    >
      <img
        src="@shared/assets/img/general/loading.svg"
        alt="loading"
      >
    </div>
    <ProviderPlan
      v-if="!loadingPlans"
      :partnerSettings="partnerSettings"
      :currentCorporation="currentCorporation"
      :plans="plans"
      :update="update"
      :toggleActionModal="toggleActionModal"
    />
    <CustomComfortCredit
      v-if="!loadingPlans && plans.length > 0"
      :partnerSettings="partnerSettings"
      :adminRole="adminRole"
      :update="updateSettings"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import providerPlanMixin from '@shared/mixins/providerPlanMixin';

import ProviderPlan from '@shared/components/partnerSettings/ProviderPlan.vue';
import CustomComfortCredit from '@shared/components/partnerSettings/CustomComfortCredit.vue';
import PromoTable from '@shared/components/promo/PromoTable.vue';

export default {
  name: 'ProviderPlanSection',
  components: {
    ProviderPlan,
    PromoTable,
    CustomComfortCredit,
  },
  mixins: [partnerSettingsMixin, providerPlanMixin],
  props: {
    partnerSettings: Object,
    currentCorporation: Object,
    toggleActionModal: Function,
    update: Function,
    updateSettings: Function,
  },
  data() {
    return {
      loadingPlans: false,
    };
  },
  async mounted() {
    this.loadingPlans = true;
    await this.$store.dispatch('getProviderPlans', {
      corpId: this.currentCorporation.id,
    });
    this.loadingPlans = false;
  },
};
</script>

<style lang="scss" scoped>
.s-setting-container {
  display: flex !important;
  flex-direction: column;
}
</style>
